module.exports = __webpack_public_path__ + "img/stock6.dc9e1042.png";